export const LISTING_STATUS = {
  NONE: '',
  RESERVED: 'reserved',
  SOLD: 'sold',
  RENTED: 'rented',
};

export const LISTING_STATUS_OPTIONS = [
  { value: LISTING_STATUS.NONE, labelKey: 'admin.form.listingStatusNone' },
  { value: LISTING_STATUS.RESERVED, labelKey: 'propertyDetails.reserved' },
  { value: LISTING_STATUS.SOLD, labelKey: 'propertyDetails.sold' },
  { value: LISTING_STATUS.RENTED, labelKey: 'propertyDetails.rented' },
];

export const resolveListingStatus = (property) => {
  if (!property) return LISTING_STATUS.NONE;
  if (property.listingStatus) return property.listingStatus;
  if (property.featured === true) return LISTING_STATUS.RESERVED;
  return LISTING_STATUS.NONE;
};

export const getListingStatusLabel = (status, t) => {
  if (status === LISTING_STATUS.RESERVED) {
    return t('propertyDetails.reserved') || 'Rezervuar';
  }
  if (status === LISTING_STATUS.SOLD) {
    return t('propertyDetails.sold') || 'Shitur';
  }
  if (status === LISTING_STATUS.RENTED) {
    return t('propertyDetails.rented') || 'Dhënë me Qira';
  }
  return '';
};
